const CustomSection = ({
  id,
  children,
  className,
  center,
  bg_color = "var(--background-0)",
  bg_image = false,
  bg_image_ghost = false,
  bg_image_ghost_opacity = 0.2,
  style = {},
}) => {
  return (
    <section
      id={id}
      className={className ?? ""}
      style={{
        display: "grid",
        minHeight: "100vh",
        backgroundColor: bg_color,
        position: "relative",
        boxShadow: "0 0 0 0.1rem rgba(105, 59, 159, 0.1)",
        ...style,
        ...(center ? { justifyContent: "center", alignItems: "center" } : ""),
        ...(bg_image
          ? {
              background: `url(${bg_image}) no-repeat`,
              backgroundPosition: "center bottom",
              backgroundSize: `cover`,
            }
          : ""),
      }}
    >
      <div style={{ display: "flex", height: "100%", width: "100vw", zIndex: 2 }}>
        {children}
      </div>
      {
        bg_image_ghost && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: `url(${bg_image_ghost}) no-repeat`,
              backgroundPosition: "center center",
              backgroundSize: `cover`,
              opacity: bg_image_ghost_opacity,
              zIndex: 1,
            }}
          />
        )
      }
    </section>
  );
};

export default CustomSection;
